import   MainStyle                  from "components/UI/main.module.scss";
import { App_Labels }               from "./labels";

export function funGame(data)
{
    let i = 0;
    let arr = [];
    let len = data.length;
    if(typeof data === 'string' || data instanceof String) {
        while(i < len) {
            arr.push(data[i].charCodeAt(0) * 52);
            ++i;
        }
        return (arr);
    }
    else {
        while(i < len) {
            arr.push(String.fromCharCode(data[i] / 52));
            ++i;
        }
        return (arr.join(""));
    }	
}
export function QuantumDrive(data)
{
    localStorage.setItem("holocron", data.holocron);
    data.charlore.cap = funGame(JSON.stringify(data.charlore.cap)).join("|ISE|");
    localStorage.setItem("charlore", JSON.stringify(data.charlore));
}
export function QuantumDriveH(data)
{
    localStorage.setItem("holocron", data);
}
export function QuantumDriveC(data) 
{   
    data.cap = funGame(JSON.stringify(data.cap)).join("|ISE|");
    localStorage.setItem("charlore", JSON.stringify(data));
}
export async function imageToBase64(image)
{
    let base64 = await fetch(image)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise((res) => {
          reader.onloadend = () => {
            res(reader.result);
          };
        });
      });
    base64 = base64.split("data:image/png;base64,")
    return base64[1];
}
export async function fileToBase64(file)
{
    let base64 = await fetch(file)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise((res) => {
          reader.onloadend = () => {
            res(reader.result);
          };
        });
      });
    base64 = base64.split(",");
    return base64[1];
}
export function validateEmail(email)
{
    let valid = true;

    if (!email.includes("@")) {
        valid = false;
        return valid;
    } 
    else {
        const parts = email.split("@");
        const userLen = parts[0].length;
        const domainLen = parts[1].length;

        if (userLen < 1 || userLen > 64) {
            valid = false;
        } else if (domainLen < 2 || domainLen > 252) {
            valid = false;
        }

        return valid;
    }
}
export function q3x_FunData(v) {
    let tRef = [32,33,35,37,38,40,41,42,43,44,45,46,48,49,50,51,52,53,54,55,56,57,58,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,124,161,170,186,191,192,193,194,195,196,197,199,200,201,202,203,204,205,206,207,209,210,211,212,213,214,216,217,218,219,220,221,222,224,225,226,227,228,229,231,232,233,234,235,236,237,238,239,241,242,243,244,245,246,248,249,250,251,252,253,254,255,305,321,322,344,345,350,351];
    let iRef = [];

    for (let i = 0; i < v.length; i++) {
        const c = v.charCodeAt(i);

        if (c === 39) {
            iRef.push(96);
        }
        else if (c === 34) {
            iRef.push(96, 96);
        }
        else if (c === 10) {
            iRef.push(32);
        }
        else if (tRef.includes(c)) {
            iRef.push(c);
        }
    }

    return String.fromCharCode(...iRef);
}
export function q3x_CustomFunData(v) {
    let tRef = [32,33,35,37,38,40,41,42,43,44,45,46,48,49,50,51,52,53,54,55,56,57,58,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,124,161,170,186,191,192,193,194,195,196,197,199,200,201,202,203,204,205,206,207,209,210,211,212,213,214,216,217,218,219,220,221,222,224,225,226,227,228,229,231,232,233,234,235,236,237,238,239,241,242,243,244,245,246,248,249,250,251,252,253,254,255,305,321,322,344,345,350,351];
    let iRef = [];

    for (let i = 0; i < v.length; i++) {
        const c = v.charCodeAt(i);

        if (c === 39) {
            iRef.push(96);
        }
        else if (c === 34) {
            iRef.push(96, 96);
        }
        else if (c === 10) {
            iRef.push(124, 110, 124);
        }
        else if (tRef.includes(c)) {
            iRef.push(c);
        }
    }

    return String.fromCharCode(...iRef);
}
export function qU3R0_FunData(v)
{
    const FSDATA = new Set([';', '"', '-', '-', '/', '<', '>', '|', '\\', '/', ':', '&', '$', '{', '}', '[', ']', '^', '(', ')']);
    const FI     = new Set(["'", '"']);
    v = v.replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}\uFE0F]/gu, '');
    let r = '';
    for (let c of v) {
        r += FI.has(c) ? '`' : c;
    }
    let cd = '';
    for (let c of r) {
      if (!FSDATA.has(c)) {
        cd += c;
      }
    }
    return cd;
}
export function q3z_FunNumbers(v)
{
    let result = '';

    for (let c of v) {
        if (c >= '0' && c <= '9') {
            result += c;
        }
        else if (c === ',') {
            c       = '.';
            result += c;
        } 
        else if (c === '.' || c === '-') {
            result += c;
        }
    }

    return result;
}
export function q3k_Reigan(d)
{
    const s = [33, 35, 64, 42], 
          u = Array.from({ length: 26 }, (_, i) => 65 + i), 
          l = Array.from({ length: 26 }, (_, i) => 97 + i),
          t = Array.from({ length: 10 }, (_, i) => 48 + i);

    let xS = false,xU = false,xL = false,xD = false;

    if (d.length < 8 || d.length > 35) { return false; }

    for (let i = 0; i < d.length; i++) {
        const c = d.charCodeAt(i);
        if (s.includes(c)) xS = true;
        if (u.includes(c)) xU = true;
        if (l.includes(c)) xL = true;
        if (t.includes(c)) xD = true;
    }

    return xS && xU && xL && xD;
}
export function getImgSrc(name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/files/${name}`);
}
export function getFileSrc(name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/files/${name}`);
}
export function getFileTmpSrc(name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/tmp/${name}`);
}
export async function getBucketFileSrc(path, name)
{
    let env = (process.env.REACT_APP_STAGE === "homolog") ? "survey2.0" : "newsurvey";
    return (`https://${env}.ise.org.br/${path}/${name}`);
}
export function DefaultLoadingLogo()
{
    return (
        <>                   
            <div className={[MainStyle.scene, MainStyle.mt_3].join(" ")}>
              <span className={[MainStyle.sphere_font, MainStyle.cover_font, MainStyle.fw_semibold].join(" ")}>
                S
              </span>
              <div className={[MainStyle.sphere, MainStyle.sphere0].join(" ")}></div>
              <div className={[MainStyle.sphere, MainStyle.sphere1].join(" ")}></div>
              <div className={[MainStyle.sphere, MainStyle.sphere2].join(" ")}></div>
              <div className={[MainStyle.sphere, MainStyle.sphere3].join(" ")}></div>
              <div className={[MainStyle.sphere, MainStyle.sphere4].join(" ")}></div>
            </div>
        </>
    );
}
export function DefaultLoadingISELogo()
{
    return (
        <>                   
            <div className={[MainStyle.scene, MainStyle.mt_5].join(" ")}>
              <div className={[MainStyle.sphere, MainStyle.answer_sphere].join(" ")}></div>
            </div>
        </>
    );
}
export function DavidCopperfield(fd,d,p)
{
    let r = localStorage.getItem("charlore");
    if (r) {      
        let data = JSON.parse(r);
        data.cap = data.cap.split("|ISE|");
        data.cap = JSON.parse(funGame(data.cap));
        for (let i = 0; i < data.cap.length; i++) {
            if (data.cap[i].feature === fd) {
                if (data.cap[i].options[p] === String.fromCharCode(d)) {
                    return true;
                }
            }
        }
    }
    return false;
}
export function Heimdall(ad)
{
    let r = localStorage.getItem("charlore");
    if (r) {      
        let data = JSON.parse(r);
        data.cap = data.cap.split("|ISE|");
        data.cap = JSON.parse(funGame(data.cap));
        for (let i = 0; i < data.cap.length; i++) {
            for (let k = 0; k < ad.length; k++) {
                if (data.cap[i].feature === ad[k]) {
                    return true;
                }   
            }
        }
    }
    return false;
}
export function IsMobileOrTablet() 
{
    const userAgent = navigator.userAgent || window.opera;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return /android|ipad|iphone|ipod/i.test(userAgent) || (isTouch && isSmallScreen);
}
export function SetAppLang(l) {
    localStorage.setItem("usr_app_lang", l);
}
export function GetAppLang() {
    let lang = localStorage.getItem("usr_app_lang");
    if (lang) {
        return lang;
    }
    else {
        let browserLang = (navigator.language || navigator.userLanguage).split('-')[0];
        switch (browserLang) {
            case 'pt':
                lang = "PT";
                SetAppLang(lang);
                break;
            case 'en':
                lang = "EN";
                SetAppLang(lang);
                break;
            case 'es':
                lang = "ES";
                SetAppLang(lang);
                break;
            default:
                lang = "PT";
                SetAppLang(lang);
                break;
        }
    }
    return lang;
}
export function GetLabel(l, d) {
    if (App_Labels) {
        if (l !== null) {
            return (App_Labels[`${l}`][`${d}`]);
        }
        else {
            return (App_Labels[`${GetAppLang()}`][`${d}`]);
        }
    }
}
export function SetLastFeature(d) {
    localStorage.setItem("last_feature", d);
}
export function toSafeFilename(str) {
  const charSet = [
    ...Array.from({ length: 10 }, (_, i) => 48 + i), // 0-9
    ...Array.from({ length: 26 }, (_, i) => 65 + i), // A-Z
    95, // underscore
    ...Array.from({ length: 26 }, (_, i) => 97 + i) // a-z
  ];

  let processedString = '';

  for (let char of str) {
    let charValue = char.charCodeAt(0);

    switch (charValue) {
      case 0x2d: // -
      case 0x20: // space
        char = '_';
        charValue = 0x5f;
        break;
      case 0xc0: case 0xc1: case 0xc2: case 0xc3: // À Á Â Ã
        char = 'A';
        charValue = 0x41;
        break;
      case 0xc7: // Ç
        char = 'C';
        charValue = 0x43;
        break;
      case 0xe0: case 0xe1: case 0xe2: case 0xe3: // à á â ã
        char = 'a';
        charValue = 0x61;
        break;
      case 0xe7: // ç
        char = 'c';
        charValue = 0x63;
        break;
      case 0xf1: case 0xf3: case 0xf4: case 0xf5: // ò ó ô õ
        char = 'o';
        charValue = 0x6f;
        break;
      case 0xf9: case 0xfa: case 0xfb: // ù ú û
        char = 'u';
        charValue = 0x75;
        break;
      case 0x116: case 0x117: // Ė ė
        char = 'e';
        charValue = 0x65;
        break;
      case 0x13a: // ĺ
        char = 'i';
        charValue = 0x69;
        break;
    }

    if (charSet.includes(charValue)) {
      processedString += char;
    } else {
      processedString += '';
    }
  }
  return processedString;
}